import type { ApolloClient } from '@apollo/client'

import { includeIfActive } from '@/utils/apollo'

export const getRefetchQueries = (
  client: ApolloClient<object>,
  floorId?: string
) => {
  // Applicable for both "normal" incidents and market facility incidents
  const baseRefetchQueries = [
    // The Incidents table runs IncidentsTable instead of Incidents while
    // noTotalIncidentCount is on (ENG-34177), so name both and let
    // includeIfActive pick whichever is mounted. Both are guarded: the skipped
    // one sits in Apollo's standby state, which getObservableQueries('active')
    // excludes, so naming it bare would trip the "Unknown query" dev warning.
    ...includeIfActive(client, 'Incidents'),
    ...includeIfActive(client, 'IncidentsTable'),
    'FacilitiesTable',
    'facilityFloorsDrawer',
    'floorIncidents',
    'Organization',
    'TotalIncidentsKPI',
    'TotalActiveIncidentsKPI',
    'GlobalUnresolvedIncidentsCount',
  ]
  // Additional refetch queries not applicable for market facility incidents
  const floorAndDeviceRefetchQueries = ['Devices']

  return floorId
    ? [...baseRefetchQueries, ...floorAndDeviceRefetchQueries]
    : baseRefetchQueries
}
